import React from 'react';
import './GiftContextBadgeCluster.css';

const Badge = ({ variant, children, tooltip, className = '', onClick, clickable = false, ...props }) => {
    const Component = clickable ? 'button' : 'span';

    return (
        <Component
            className={`gift-badge gift-badge--${variant} ${className} ${clickable ? 'cursor-pointer hover:scale-105 transition-transform duration-200 hover:shadow-md' : ''}`}
            title={tooltip}
            onClick={onClick}
            {...props}
        >
            {children}
        </Component>
    );
};

const GiftContextBadgeCluster = ({ product, onBadgeClick }) => {
    if (!product) return null;

    const handleBadgeClick = (filterType, filterValue) => {
        if (onBadgeClick) {
            onBadgeClick(filterType, filterValue);
        }
    };

    return (
        <div className="gift-context-badges">
            {product.age_range && (
                <Badge
                    variant="age"
                    tooltip={`Click to filter by ages ${product.age_range}`}
                    clickable={!!onBadgeClick}
                    onClick={() => handleBadgeClick('age_range', product.age_range)}
                >
                    {product.age_range}
                </Badge>
            )}

            {product.gender_suitability && (
                <Badge
                    variant="gender"
                    gender={product.gender_suitability}
                    tooltip={`Click to filter by ${product.gender_suitability === 'F' ? 'Women' : product.gender_suitability === 'M' ? 'Men' : 'All Genders'}`}
                    clickable={!!onBadgeClick}
                    onClick={() => handleBadgeClick('gender_suitability', product.gender_suitability)}
                >
                    {product.gender_suitability === 'F' ? 'Women' :
                        product.gender_suitability === 'M' ? 'Men' : 'Unisex'}
                </Badge>
            )}

            {product.occasions?.map(occasion => (
                <Badge
                    key={occasion.id}
                    variant="occasion"
                    occasion={occasion.slug}
                    tooltip={`Click to filter by ${occasion.name}`}
                    clickable={!!onBadgeClick}
                    onClick={() => handleBadgeClick('occasions', occasion.id)}
                >
                    {occasion.name}
                </Badge>
            ))}

            {product.category_details && product.category_details.name && (
                <Badge
                    variant="category"
                    tooltip={`Category: ${product.category_details.name}`}
                    clickable={!!onBadgeClick}
                    onClick={() => handleBadgeClick('category', product.category_details.id || product.category_details.name)}
                >
                    {product.category_details.name}
                </Badge>
            )}
        </div>
    );
};

export default GiftContextBadgeCluster; 